import { DiagnosisForm } from "../DiagnosisForm";

export interface AddDiagnosisProps {}

export const AddDiagnosis = () => {
  return <DiagnosisForm />;
};
